import React from 'react';
import Spinner from './spinner';

function WrappedSpinner(props) {
  return props.isLoading ? <Spinner /> : props.children;
}

export default WrappedSpinner;
